import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Techniques from "@/pages/Techniques";
import Gallery from "@/pages/Gallery";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Press from "@/pages/Press";
import Commission from "@/pages/Commission";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminVerify from "@/pages/admin/AdminVerify";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/colin-darke" element={<About />} />
            <Route path="/techniques" element={<Techniques />} />
            <Route path="/artwork" element={<Gallery />} />
            <Route path="/artwork/:id" element={<ArtworkDetail />} />
            <Route path="/press" element={<Press />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/verify" element={<AdminVerify />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A18",
              color: "#F9F8F3",
              border: "1px solid #2A2A26",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
